module.exports = __webpack_public_path__ + "media/customizations/lifeatkiawahriver/logo-new-55ea098342076ef9aaa07ff80af1594c.png";